var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWifiOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.793 8.835l1.414 1.414c.504-.504 1.052-.95 1.622-1.36L3.4 7.462c-.56.422-1.104.87-1.607 1.374zM6.974 5.5L4.207 2.733 2.793 4.147l18 18 1.414-1.414-5.012-5.012.976-.975a7.86 7.86 0 00-4.099-2.148l-2.278-2.278c2.789-.191 5.649.748 7.729 2.827l1.414-1.414c-2.898-2.9-7.061-3.936-10.888-3.158L8.524 7.05a13.366 13.366 0 013.976-.61c3.537 0 6.837 1.353 9.293 3.809l1.414-1.414C20.374 6 16.571 4.44 12.5 4.44A15.198 15.198 0 006.974 5.5zm-2.911 6.233l1.414 1.414a9.563 9.563 0 012.058-1.551l-1.459-1.46c-.717.452-1.395.98-2.013 1.597zm2.766 3.014l1.414 1.414c.692-.692 1.535-1.151 2.429-1.428l-1.557-1.557a7.76 7.76 0 00-2.286 1.57zm7.66 3.803l-2.1-2.1a1.996 1.996 0 102.1 2.1z",
    fill: "#52575C"
  })));
}

export default SvgWifiOff;